import { createRouter, createWebHistory } from 'vue-router'
import { getToken, getUser, setUser, hasPermission, rebuildPermissionCache } from '../utils/auth'
import request from '../api'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '工作台' }
      },
      // ---- 商户管理 ----
      {
        path: 'merchant/list',
        name: 'MerchantList',
        component: () => import('../views/merchant/MerchantList.vue'),
        meta: { title: '商户管理', permission: 'merchant:list' }
      },
      // ---- API 服务管理 ----
      {
        path: 'api/category',
        name: 'ApiCategory',
        component: () => import('../views/api/ApiCategory.vue'),
        meta: { title: 'API分类管理', permission: 'api:list' }
      },
      {
        path: 'api/list',
        name: 'ApiList',
        component: () => import('../views/api/ApiList.vue'),
        meta: { title: 'API目录管理', permission: 'api:list' }
      },
      // ---- 套餐管理 ----
      {
        path: 'plan/list',
        name: 'PlanList',
        component: () => import('../views/plan/PlanList.vue'),
        meta: { title: '套餐管理', permission: 'plan:list' }
      },
      {
        path: 'plan/package',
        name: 'PackageList',
        component: () => import('../views/plan/PackageList.vue'),
        meta: { title: '充值套餐包', permission: 'plan:package' }
      },
      // ---- 统计报表 ----
      {
        path: 'stats/calls',
        name: 'StatsCalls',
        component: () => import('../views/stats/CallStatsView.vue'),
        meta: { title: '调用统计', permission: 'stats:calls' }
      },
      {
        path: 'stats/revenue',
        name: 'StatsRevenue',
        component: () => import('../views/stats/RevenueStatsView.vue'),
        meta: { title: '收入统计', permission: 'stats:revenue' }
      },
      // ---- 商户管理(续) ----
      {
        path: 'merchant/audit',
        name: 'MerchantAudit',
        component: () => import('../views/merchant/MerchantAudit.vue'),
        meta: { title: '商户审核', permission: 'merchant:audit' }
      },
      // ---- API管理(续) ----
      {
        path: 'api/upstream',
        name: 'ApiUpstream',
        component: () => import('../views/api/ApiUpstream.vue'),
        meta: { title: '上游配置', permission: 'api:upstream:list' }
      },
      // ---- 统计报表(续) ----
      {
        path: 'stats/alert',
        name: 'StatsAlert',
        component: () => import('../views/stats/AlertView.vue'),
        meta: { title: '异常监控', permission: 'stats:alert' }
      },
      // ---- 日志 ----
      {
        path: 'log/call',
        name: 'CallLog',
        component: () => import('../views/log/CallLogList.vue'),
        meta: { title: '调用日志', permission: 'log:call' }
      },
      {
        path: 'system/oplog',
        name: 'OperationLog',
        component: () => import('../views/system/OperationLog.vue'),
        meta: { title: '操作日志', permission: 'log:operation' }
      },
      {
        path: 'system/loginlog',
        component: () => import('../views/log/LoginLogList.vue'),
        meta: { title: '登录日志', permission: 'log:login:list' }
      },
      // ---- 财务管理 ----
      {
        path: 'finance/recharge',
        name: 'FinanceRecharge',
        component: () => import('../views/finance/RechargeList.vue'),
        meta: { title: '充值记录', permission: 'finance:recharge:list' }
      },
      {
        path: 'finance/invoice',
        name: 'FinanceInvoice',
        component: () => import('../views/finance/InvoiceList.vue'),
        meta: { title: '发票管理', permission: 'finance:invoice:list' }
      },
      {
        path: 'finance/bill',
        name: 'FinanceBill',
        component: () => import('../views/finance/BillList.vue'),
        meta: { title: '商户账单', permission: 'finance:bill:list' }
      },
      // ---- 营销管理 ----
      {
        path: 'marketing/coupon',
        name: 'MarketingCoupon',
        component: () => import('../views/marketing/CouponList.vue'),
        meta: { title: '优惠券', permission: 'marketing:coupon:list' }
      },
      {
        path: 'marketing/referral',
        name: 'MarketingReferral',
        component: () => import('../views/marketing/ReferralList.vue'),
        meta: { title: '推荐返利', permission: 'marketing:referral:list' }
      },
      // ---- 客户支持 ----
      {
        path: 'support/ticket',
        name: 'SupportTicket',
        component: () => import('../views/support/TicketList.vue'),
        meta: { title: '工单管理', permission: 'support:ticket:list' }
      },
      {
        path: 'support/health',
        name: 'SupportHealth',
        component: () => import('../views/support/HealthView.vue'),
        meta: { title: '商户健康度', permission: 'support:health:list' }
      },
      // ---- 系统管理 ----
      {
        path: 'system/menu',
        name: 'MenuManage',
        component: () => import('../views/system/MenuList.vue'),
        meta: { title: '菜单管理', permission: 'system:menu' }
      },
      {
        path: 'system/role',
        name: 'RoleManage',
        component: () => import('../views/system/RoleList.vue'),
        meta: { title: '角色管理', permission: 'system:role' }
      },
      {
        path: 'system/user',
        name: 'UserManage',
        component: () => import('../views/system/UserList.vue'),
        meta: { title: '用户管理', permission: 'system:user' }
      }
    ]
  },
  // 404 兜底
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 是否正在拉取权限
let _fetchingPerms = false
// 权限版本标记（每次页面加载只拉一次）
let _fetchedThisLoad = false

// 路由守卫（异步）
router.beforeEach(async (to, from, next) => {
  const token = getToken()

  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - API聚合平台`
  }

  // 登录页特殊处理
  if (to.path === '/login') {
    if (token) {
      next('/')
    } else {
      next()
    }
    return
  }

  // 未登录 → 跳登录页
  if (!token) {
    next('/login')
    return
  }

  // 每次页面加载时拉取一次最新权限（解决权限变更后旧缓存问题）
  if (!_fetchedThisLoad && !_fetchingPerms) {
    _fetchingPerms = true
    try {
      const info = await request.get('/admin/auth/info')
      if (info) {
        const oldUser = getUser() || {}
        setUser({
          ...oldUser,
          ...info,
          permissions: info.permissions || []
        })
        rebuildPermissionCache()
      }
    } catch (e) {
      console.warn('路由守卫：刷新权限失败', e)
    } finally {
      _fetchingPerms = false
      _fetchedThisLoad = true
    }
  }

  // 路由级权限检查
  if (to.meta.permission) {
    if (!hasPermission(to.meta.permission)) {
      console.warn(`[Router] 无权限访问 ${to.path}（需要 ${to.meta.permission}）`)
      // 静默弹回工作台曾把"菜单/权限数据缺失"掩盖成无感知跳转(缺陷#37), 必须给用户可见提示
      import('element-plus').then(({ ElMessage }) => {
        ElMessage.warning(`无权限访问「${to.meta.title || to.path}」，如属异常请联系管理员检查菜单配置`)
      })
      next('/dashboard')
      return
    }
  }

  next()
})

export default router
